import * as z from 'zod';
/**
 * Why playback is or is not permitted right now.
 *
 * This enum is the interface between three separate concerns:
 *
 * - the policy engine, which decides;
 * - the backend, which reports the decision without any user-facing prose;
 * - the two applications, which translate it — a parent and a three-year-old
 *   need very different sentences for the same code.
 *
 * Adding a member therefore requires a translation in every locale of every
 * app. That cost is intentional: it prevents silent, untranslated states.
 */
export const playbackGateReasonSchema = z.enum([
    /** Playback may proceed. */
    'ALLOWED',
    /** Default deny: the item is not in this child's approved library. */
    'CONTENT_NOT_APPROVED',
    /** Subscription entitlement or feature flag withholds the capability. */
    'FEATURE_UNAVAILABLE',
    /** Outside the hours the schedule permits. */
    'OUT_OF_SCHEDULE',
    /** The daily budget across all content types is spent. */
    'DAILY_BUDGET_EXHAUSTED',
    /** The budget for this particular content type is spent. */
    'TYPE_BUDGET_EXHAUSTED',
    /** A mandatory screen rest is in progress. */
    'REST_PERIOD',
    /** A parent paused or locked the device. */
    'PARENT_PAUSED',
    /** The maximum uninterrupted session length is reached. */
    'SESSION_LIMIT',
    /** A movement activity must be completed before playback resumes. */
    'MOVEMENT_BREAK',
]);
//# sourceMappingURL=playback-gate.js.map